"use client";

import { motion } from "framer-motion";
import EditableElement from "@/components/customize/EditableElement";

export default function Thankyou({
  heading, message, background,
  templateMeta,
  __isMobile = false,
  __isEditable = false,
  __sectionId,
  __onFieldEdit,
  __onFieldChange,
  __focusFieldName,
}) {
  const fadeInUp = {
    hidden: { opacity: 0, y: 40 },
    show: { opacity: 1, y: 0, transition: { duration: 0.6 } },
  };
  
  const signature = `- ${templateMeta?.groomFirstName || "Groom"} & ${templateMeta?.brideFirstName || "Bride"} -`;

  return (
    <div className="relative w-full h-93.75">
      <div className="absolute top-0 left-0 w-full h-full bg-black/40" />

      {/* Content */}
      <motion.div
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.2 }}
        variants={fadeInUp}
        className="relative z-50 px-8 text-center flex items-center justify-center h-full w-full"
      >
        <div className="text-white">
          {heading && (
            <EditableElement
              type="text"
              value={heading}
              onChange={(val) => __onFieldChange?.(__sectionId, "heading", val)}
              isEditable={__isEditable}
              fieldName="heading"
              onEditStart={() => __onFieldEdit?.(__sectionId, "heading")}
              isActive={__focusFieldName === "heading"}
              isMobile={__isMobile}
            >
              <h1 className="text-6xl font-caudex">{heading}</h1>
            </EditableElement>
          )}
          {message && (
            <EditableElement
              type="text"
              value={message}
              onChange={(val) => __onFieldChange?.(__sectionId, "message", val)}
              isEditable={__isEditable}
              fieldName="message"
              onEditStart={() => __onFieldEdit?.(__sectionId, "message")}
              isActive={__focusFieldName === "message"}
              isMobile={__isMobile}
              useContentEditable={true}
              multiline={true}
            >
              <p className="text-xs my-3">{message}</p>
            </EditableElement>
          )}
          {signature && (
            <EditableElement
              type="text"
              value={signature}
              isEditable={__isEditable}
              fieldName="thankyouSignature"
              onEditStart={() => __onFieldEdit?.("general", "groomFirstName")}
              useContentEditable={false}
              className="mt-4"
            >
              <p className="font-caudex">{signature}</p>
            </EditableElement>
          )}
        </div>
      </motion.div>
    </div>
  );
}
